import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import SafetyNotice from '../../../components/base/SafetyNotice';
import AffiliateDisclosure from '../../../components/base/AffiliateDisclosure';
import { Link } from 'react-router-dom';
import { mobilityProducts } from '../../../mocks/affiliate-products';
import SEOHead from '../../../components/base/SEOHead';

export default function MobilityNeedPage() {
  const products = [
    {
      name: 'Anti-Rutsch-Socken für Hunde',
      image: 'https://public.readdy.ai/ai/img_res/caa49641012ebdcf7fe6a1fe87ad910f.jpg',
      reason: 'Anti-Rutsch-Socken bieten sofortigen Grip auf glatten Böden und schützen gleichzeitig empfindliche Pfoten. Sie sind eine kostengünstige erste Lösung.',
      suitableFor: ['Leichtes Rutschen', 'Innenbereich', 'Schnelle Anpassung'],
      amazonLink: 'https://www.amazon.de/Anti-Rutsch-Hundesocken-Pfotenschutz-verstellbarem-Klettverschluss-Au%C3%9Fenbereich/dp/B0D8KT9W6R/ref=sr_1_6?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=2ZZJNZ5B98J8M&dib=eyJ2IjoiMSJ9.PGqHFQrR7X-l_MJ5q_67qrfYJ2vac12J_NtBuAkMgI_BGSUc_0-kwRCNvLAE_erdiqVLu8vAXdGmkSv7TUkWv_2-1-FrWe5iDtBNXK3KiiL0U3aVEqC5ghenA4t8zBC-rbyeBgk45nJAuBn3DU9SIB3I13iuTGrUlFaMyCGVHvlO2j1c7q3I0iWwkQd6c9SDM1l-Ph-6_PtMKQ0n1lBz1SBFujHcm9I9FezDNPsQe7wlFcgsYF0aqhbhJzzYI9xz1mvC0fcvC6371ngC1TeHSnYAJVosfeDr7vXBfTHtHXU.Qysr1LWsYCePqTXPApx2I8azgz5bqz7Pecxbb9Ygiac&dib_tag=se&keywords=hundesocken%2Bsenior&qid=1770124255&sprefix=hundesocken%2Bsenior%2Caps%2C185&sr=8-6&th=1',
      zooplusLink: '#',
    },
    {
      name: 'Hundeschuhe mit Profil',
      image: 'https://public.readdy.ai/ai/img_res/edited_990d0c48df2b6267406e52a570378be4_460383e7.jpg',
      reason: 'Hundeschuhe bieten maximalen Halt und schützen die Pfoten auch draußen. Ideal für Hunde mit stärkeren Mobilitätsproblemen.',
      suitableFor: ['Starkes Rutschen', 'Innen und außen', 'Pfotenschutz'],
      amazonLink: '#',
      zooplusLink: '#',
    },
    {
      name: 'Anti-Rutsch-Matten & Läufer',
      image: 'https://readdy.ai/api/search-image?query=non%20slip%20rubber%20mat%20runner%20for%20dogs%20on%20floor%20product%20photography%20neutral%20background%20showing%20textured%20surface%20and%20practical%20placement&width=400&height=400&seq=prod-mobility-003&orientation=squarish',
      reason: 'Matten schaffen sichere Laufwege auf glatten Böden. Sie sind eine dauerhafte Lösung, die keine Anpassung am Hund erfordert.',
      suitableFor: ['Häufig genutzte Wege', 'Keine Anpassung am Hund nötig', 'Langfristige Lösung'],
      amazonLink: '#',
      zooplusLink: '#',
    },
    {
      name: 'Aufstehhilfe & Tragehilfe',
      image: 'https://readdy.ai/api/search-image?query=dog%20lifting%20harness%20support%20sling%20for%20senior%20dogs%20product%20photography%20simple%20background%20showing%20comfortable%20design%20and%20supportive%20structure&width=400&height=400&seq=prod-mobility-004&orientation=squarish',
      reason: 'Tragehilfen unterstützen beim Aufstehen und Treppensteigen. Sie entlasten schwache Hinterbeine und geben Sicherheit.',
      suitableFor: ['Schwierigkeiten beim Aufstehen', 'Treppensteigen', 'Hinterbein-Schwäche'],
      amazonLink: '#',
      zooplusLink: '#',
    },
  ];

  return (
    <div className="min-h-screen bg-sand">
      <SEOHead 
        title="Mobilität & Aufstehen beim Seniorhund | Hund im Alter"
        description="Hilfe bei Mobilitätsproblemen: Anti-Rutsch-Socken, Tragehilfen und Tipps wenn Ihr alter Hund rutscht oder schwer aufsteht."
        keywords="Hund rutscht, Seniorhund Mobilität, Aufstehhilfe Hund, Anti-Rutsch Hund"
      />
      <Header />
      <main className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="text-sm text-gray-500 mb-6">
            <Link to="/" className="hover:text-teal">Start</Link>
            <span className="mx-2">/</span>
            <Link to="/beduerfnisse" className="hover:text-teal">Bedürfnisse</Link>
            <span className="mx-2">/</span>
            <span className="text-navy">Mobilität & Aufstehen</span>
          </nav>

          {/* Page Header */}
          <div className="mb-12 bg-gradient-to-br from-teal/10 via-white to-sand rounded-3xl p-8 md:p-12 border border-teal/20">
            <div className="flex flex-col md:flex-row items-start gap-6">
              <div className="w-16 h-16 flex items-center justify-center bg-teal/20 rounded-2xl flex-shrink-0">
                <i className="fa-solid fa-paw text-5xl text-teal"></i>
              </div>
              <div className="flex-1">
                <h1 className="text-4xl md:text-5xl font-bold text-navy leading-tight mb-4">
                  Mobilität & Aufstehen
                </h1>
                <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                  Wenn ältere Hunde auf glatten Böden rutschen oder Schwierigkeiten beim Aufstehen haben, liegt das an nachlassender Muskelkraft und Gelenkproblemen. Hier finden Sie praktische Unterstützung.
                </p>
                <div className="flex flex-wrap gap-3 mt-6">
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-navy font-medium shadow-sm">
                    <i className="ri-footprint-line mr-2 text-teal"></i>Sicherer Halt
                  </span>
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-navy font-medium shadow-sm">
                    <i className="ri-hand-heart-line mr-2 text-teal"></i>Unterstützend
                  </span>
                  <span className="px-4 py-2 bg-white rounded-full text-sm text-navy font-medium shadow-sm">
                    <i className="ri-shield-star-line mr-2 text-teal"></i>Rutschfest
                  </span>
                </div>
              </div>
            </div>
          </div>

          <SafetyNotice />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-12">
            {/* Main Content */}
            <div className="lg:col-span-2 space-y-12">
              {/* Problem Recognition */}
              <section className="bg-white rounded-2xl p-10">
                <h2 className="text-3xl font-bold text-navy mb-6">
                  Woran Sie merken, dass dieses Bedürfnis besteht
                </h2>
                <ul className="space-y-4 text-lg text-gray-700 leading-relaxed">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal text-xl mt-1 flex-shrink-0"></i>
                    <span>Ihr Hund rutscht auf Fliesen, Laminat oder Parkett</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal text-xl mt-1 flex-shrink-0"></i>
                    <span>Aufstehen dauert länger und erfordert mehrere Anläufe</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal text-xl mt-1 flex-shrink-0"></i>
                    <span>Die Hinterbeine knicken beim Laufen ein</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal text-xl mt-1 flex-shrink-0"></i>
                    <span>Ihr Hund vermeidet glatte Böden oder bewegt sich vorsichtiger</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal text-xl mt-1 flex-shrink-0"></i>
                    <span>Treppensteigen wird zur Herausforderung</span>
                  </li>
                </ul>
              </section>

              {/* Why This Happens */}
              <section className="bg-white rounded-2xl p-10">
                <h2 className="text-3xl font-bold text-navy mb-6">
                  Warum das im Alter passiert
                </h2>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                  Mit zunehmendem Alter verlieren Hunde Muskelmasse, besonders in den Hinterbeinen. Die Gelenke werden steifer, und Arthrose kann die Beweglichkeit einschränken.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                  Gleichzeitig lässt die Koordination nach. Die Pfotenballen werden trockener und verlieren an Grip. Das Zusammenspiel dieser Faktoren macht glatte Böden zu einer echten Herausforderung.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Das Rutschen verunsichert viele Hunde zusätzlich, was zu noch vorsichtigerem Bewegungsverhalten führt.
                </p>
              </section>

              {/* What Helps */}
              <section className="bg-white rounded-2xl p-10">
                <h2 className="text-3xl font-bold text-navy mb-6">
                  Was realistisch hilft
                </h2>
                <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                  <div>
                    <h3 className="text-xl font-semibold text-navy mb-3">Sofortmaßnahmen:</h3>
                    <ul className="space-y-3 ml-6">
                      <li className="flex items-start gap-3">
                        <span className="text-teal mt-1">•</span>
                        <span>Anti-Rutsch-Socken oder Hundeschuhe für besseren Grip</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-teal mt-1">•</span>
                        <span>Rutschfeste Matten auf häufig genutzten Wegen auslegen</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-teal mt-1">•</span>
                        <span>Tragehilfen zum Unterstützen beim Aufstehen</span>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-navy mb-3">Langfristige Unterstützung:</h3>
                    <ul className="space-y-3 ml-6">
                      <li className="flex items-start gap-3">
                        <span className="text-teal mt-1">•</span>
                        <span>Sanfte Bewegung zur Erhaltung der Muskulatur (kurze, regelmäßige Spaziergänge)</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-teal mt-1">•</span>
                        <span>Physiotherapie oder Hydrotherapie nach tierärztlicher Empfehlung</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <span className="text-teal mt-1">•</span>
                        <span>Gewichtskontrolle zur Entlastung der Gelenke</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>

              {/* Product Recommendations */}
              <section>
                <h2 className="text-3xl font-bold text-navy mb-6">
                  Seniorpaw empfiehlt
                </h2>
                
                <AffiliateDisclosure />

                <div className="space-y-8 mt-8">
                  {products.map((product, index) => (
                    <div key={index} className="bg-white rounded-2xl p-8 shadow-sm">
                      <div className="flex flex-col md:flex-row gap-6">
                        <div className="w-full md:w-48 h-48 flex-shrink-0">
                          <img
                            src={product.image}
                            alt={product.name}
                            className="w-full h-full object-cover rounded-xl"
                          />
                        </div>
                        <div className="flex-1">
                          <h3 className="text-2xl font-bold text-navy mb-4">
                            {product.name}
                          </h3>
                          <div className="mb-4">
                            <h4 className="text-base font-semibold text-teal mb-2">
                              Warum diese Lösung hilft:
                            </h4>
                            <p className="text-base text-gray-700 leading-relaxed">
                              {product.reason}
                            </p>
                          </div>
                          <div className="mb-6">
                            <h4 className="text-base font-semibold text-navy mb-2">
                              Geeignet für:
                            </h4>
                            <ul className="space-y-2">
                              {product.suitableFor.map((item, idx) => (
                                <li key={idx} className="flex items-center gap-2 text-base text-gray-700">
                                  <i className="ri-check-line text-teal"></i>
                                  <span>{item}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div className="flex flex-wrap gap-3">
                            <a
                              href={product.amazonLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="px-6 py-3 bg-navy text-white rounded-full font-medium hover:bg-navy-dark transition-colors whitespace-nowrap cursor-pointer"
                            >
                              Bei Amazon ansehen
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <div className="sticky top-32 space-y-6">
                {/* Info Box */}
                <div className="bg-sand border-l-4 border-teal rounded-xl p-6">
                  <h3 className="text-lg font-bold text-navy mb-4">
                    Wichtige Hinweise
                  </h3>
                  <ul className="space-y-3 text-sm text-gray-700">
                    <li className="flex items-start gap-2">
                      <i className="ri-information-line text-teal mt-0.5"></i>
                      <span>Gewöhnen Sie Ihren Hund langsam an Socken oder Schuhe</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-information-line text-teal mt-0.5"></i>
                      <span>Überprüfen Sie die Passform regelmäßig</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-information-line text-teal mt-0.5"></i>
                      <span>Kombinieren Sie mehrere Lösungen für beste Ergebnisse</span>
                    </li>
                  </ul>
                </div>

                {/* Vet Notice */}
                <div className="bg-yellow-50 border-l-4 border-orange-400 rounded-xl p-6">
                  <h3 className="text-lg font-bold text-navy mb-3 flex items-center gap-2">
                    <i className="ri-stethoscope-line text-orange-500"></i>
                    Wann zum Tierarzt?
                  </h3>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start gap-2">
                      <span className="text-orange-500 mt-0.5">•</span>
                      <span>Plötzliche Lahmheit</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-500 mt-0.5">•</span>
                      <span>Schmerzen beim Bewegen</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-500 mt-0.5">•</span>
                      <span>Schwellungen an Gelenken</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-500 mt-0.5">•</span>
                      <span>Vollständige Bewegungsunfähigkeit</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-500 mt-0.5">•</span>
                      <span>Schnelle Verschlechterung</span>
                    </li>
                  </ul>
                </div>

                {/* Related Needs */}
                <div className="bg-white rounded-xl p-6">
                  <h3 className="text-lg font-bold text-navy mb-4">
                    Weitere Bedürfnisse
                  </h3>
                  <ul className="space-y-3">
                    <li>
                      <Link to="/beduerfnisse/komfort-liegen" className="text-base text-teal hover:underline cursor-pointer">
                        Komfort & Liegen →
                      </Link>
                    </li>
                    <li>
                      <Link to="/beduerfnisse/hygiene-pflege" className="text-base text-teal hover:underline cursor-pointer">
                        Hygiene & Pflege →
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
